import { actions } from 'common/store/resource';

export const NAMESPACE = 'DEVICE';

const resourceActions = actions.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  CLEAR,
} = resourceActions.TYPES;

export const LOAD_DEVICE_DASHBOARD = "DEVICE/LOAD_DEVICE_DASHBOARD";
export const LOAD_DEVICE_DASHBOARD_SUCCESS = "DEVICE/LOAD_DEVICE_DASHBOARD_SUCCESS";

export const {
  loadSuccess,
  loadError,
  clear,
} = resourceActions;

export const load = deviceId => ({
  ...resourceActions.load(),
  deviceId,
});

export const loadDeviceDashboard = deviceId => ({
  type: LOAD_DEVICE_DASHBOARD,
  deviceId,
});

export const loadDeviceDashboardSuccess = dets => ({
  type: LOAD_DEVICE_DASHBOARD_SUCCESS,
  dets,
});

